module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAA9CAYAAADrnOpZAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEwSURBVHgB7drLTQMxFIXh48tjB0o6cAmUQDqgA1hGbKADkg7CJmJJCXQA6YAS3EEi2PEY44sgAkGyPXOl80kZWXEW/jOeWTnhy/IyD3ZfcIGEY9T24Vol4O61w3R4U8q2Hya/LMc57xnuK5DRP5ODeZlumjS/9HjxbvJ8nq82TdrTOJ/1ePHfNkaY7bR9H8O/EVYrjhDHnwhDPL8iIga4dURqg4qoOoyi3oFPyXAaOqBtnZPQAc0gekDYt9CaAtgUwKYANgWwKYBNAWwKYFMAmwLYFMCmADYFsCmATQFsCmBTAJsC2BTApgA2BbApgM1Q8YC4Hq1LWCCoClxbt49ZGxQE42s+nJdbG87K6r3DKFKEr9XX7OP0c8IPwSY/R9rXo5ipPa8Vi7e2a/yP968+AJOLT1cbyr80AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/uP01.png
// module id = Bi8b
// module chunks = 1